import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import Select from 'react-select';
import Constants from "../../Constants";
import jQuery from "jquery";

export default function ProjectDetailsOffline() {
	const scrollRef = useRef(null);
  	const { t } = useTranslation();
  	const translate = t;
	
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
	    <Header ref={scrollRef} />
        <LeftNavbar />
	<section className="dashboard-content">
	  <div id="content" className="dashboard-wrap">
	      <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
         <div className="project-offline-page">
			<div className="white-bg">
              <div className="marketo-top-heading flex-center">
                <h4>Source Materials for</h4>
                <button>UBERFLIIP UI</button>
              </div>
              <div className="wrap-dropdown mar-bot30">
                <div className="global-dropdown-block m-0 w-330">
                    <label>What is your source language?</label>
                    <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Select Language' }}
                    />
                </div>
                <div className="cust-arrow"></div>
                <div className="global-dropdown-block m-0 w-330">
                    <label>What languages do you want to translate to?</label>
                    <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Select Multiple Language' }}
                    />
                      <div className="multiselect-output flex">
                       <button aria-label="English us">
                         <strong>English (US)</strong>
                         <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none"><path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                       </button>
                      </div>
                </div>
              </div>
              <div className="details-offline-block">
                 <h5>Victory LAP part two; an Insider's Perspective</h5>
                 <div className="flex wrap-dropdown  gap20">
                   <div className="global-dropdown-block m-0">
                     <label>Target Language</label>
                     <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Chinese(Simplified)' }}
                    />
                   </div>
                   <div className="global-dropdown-block m-0">
                     <label>Select Hubs</label>
                     <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Select Hub' }}
                    />
                   </div>
                   <div className="global-dropdown-block m-0">
                     <label>Select Stream</label>
                     <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Select Stream' }}
                    />
                   </div>
                   <div className="flex btn-gap border-line">
                      <button className="blue-btn" aria-label="Delete">
                        <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                          <path d="M8.92461 4.19922H12.0746C12.0746 3.7815 11.9087 3.3809 11.6133 3.08553C11.3179 2.79016 10.9173 2.62422 10.4996 2.62422C10.0819 2.62422 9.68129 2.79016 9.38592 3.08553C9.09055 3.3809 8.92461 3.7815 8.92461 4.19922ZM7.87461 4.19922C7.87461 3.50303 8.15117 2.83535 8.64345 2.34306C9.13574 1.85078 9.80342 1.57422 10.4996 1.57422C11.1958 1.57422 11.8635 1.85078 12.3558 2.34306C12.848 2.83535 13.1246 3.50303 13.1246 4.19922H18.3746C18.5138 4.19922 18.6474 4.25453 18.7458 4.35299C18.8443 4.45144 18.8996 4.58498 18.8996 4.72422C18.8996 4.86346 18.8443 4.99699 18.7458 5.09545C18.6474 5.19391 18.5138 5.24922 18.3746 5.24922H17.2679L16.0142 16.1104C15.9256 16.8782 15.5578 17.5865 14.9809 18.1008C14.4039 18.615 13.6581 18.8992 12.8852 18.8992H8.11401C7.34116 18.8992 6.5953 18.615 6.01835 18.1008C5.4414 17.5865 5.07363 16.8782 4.98501 16.1104L3.73131 5.24922H2.62461C2.48537 5.24922 2.35184 5.19391 2.25338 5.09545C2.15492 4.99699 2.09961 4.86346 2.09961 4.72422C2.09961 4.58498 2.15492 4.45144 2.25338 4.35299C2.35184 4.25453 2.48537 4.19922 2.62461 4.19922H7.87461ZM6.02766 15.9907C6.08691 16.5025 6.33221 16.9746 6.7169 17.3173C7.10159 17.66 7.59882 17.8493 8.11401 17.8492H12.8852C13.4004 17.8493 13.8976 17.66 14.2823 17.3173C14.667 16.9746 14.9123 16.5025 14.9716 15.9907L16.2106 5.24922H4.78866L6.02766 15.9907ZM8.92461 7.87422C9.06385 7.87422 9.19738 7.92953 9.29584 8.02799C9.3943 8.12644 9.44961 8.25998 9.44961 8.39922V14.6992C9.44961 14.8385 9.3943 14.972 9.29584 15.0705C9.19738 15.1689 9.06385 15.2242 8.92461 15.2242C8.78537 15.2242 8.65183 15.1689 8.55338 15.0705C8.45492 14.972 8.39961 14.8385 8.39961 14.6992V8.39922C8.39961 8.25998 8.45492 8.12644 8.55338 8.02799C8.65183 7.92953 8.78537 7.87422 8.92461 7.87422ZM12.5996 8.39922C12.5996 8.25998 12.5443 8.12644 12.4458 8.02799C12.3474 7.92953 12.2138 7.87422 12.0746 7.87422C11.9354 7.87422 11.8018 7.92953 11.7034 8.02799C11.6049 8.12644 11.5496 8.25998 11.5496 8.39922V14.6992C11.5496 14.8385 11.6049 14.972 11.7034 15.0705C11.8018 15.1689 11.9354 15.2242 12.0746 15.2242C12.2138 15.2242 12.3474 15.1689 12.4458 15.0705C12.5443 14.972 12.5996 14.8385 12.5996 14.6992V8.39922Z" fill="#1D4ED8"/>
                        </svg>
                        <span>Delete</span>
                      </button>
                   </div>
                 </div>
                 <div className="flex wrap-dropdown  gap20">
                   <div className="global-dropdown-block m-0">
                     <label>Target Language</label>
                     <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Chinese(Simplified)' }}
                    />
                   </div>
                   <div className="global-dropdown-block m-0">
                     <label>Select Hubs</label>
                     <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Select Hub' }}
                    />
                   </div>
                   <div className="global-dropdown-block m-0">
                     <label>Select Stream</label>
                     <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Select Stream' }}
                    />
                   </div>
                   <div className="flex btn-gap border-line">
                      <button className="blue-btn" aria-label="Delete">
                        <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                          <path d="M8.92461 4.19922H12.0746C12.0746 3.7815 11.9087 3.3809 11.6133 3.08553C11.3179 2.79016 10.9173 2.62422 10.4996 2.62422C10.0819 2.62422 9.68129 2.79016 9.38592 3.08553C9.09055 3.3809 8.92461 3.7815 8.92461 4.19922ZM7.87461 4.19922C7.87461 3.50303 8.15117 2.83535 8.64345 2.34306C9.13574 1.85078 9.80342 1.57422 10.4996 1.57422C11.1958 1.57422 11.8635 1.85078 12.3558 2.34306C12.848 2.83535 13.1246 3.50303 13.1246 4.19922H18.3746C18.5138 4.19922 18.6474 4.25453 18.7458 4.35299C18.8443 4.45144 18.8996 4.58498 18.8996 4.72422C18.8996 4.86346 18.8443 4.99699 18.7458 5.09545C18.6474 5.19391 18.5138 5.24922 18.3746 5.24922H17.2679L16.0142 16.1104C15.9256 16.8782 15.5578 17.5865 14.9809 18.1008C14.4039 18.615 13.6581 18.8992 12.8852 18.8992H8.11401C7.34116 18.8992 6.5953 18.615 6.01835 18.1008C5.4414 17.5865 5.07363 16.8782 4.98501 16.1104L3.73131 5.24922H2.62461C2.48537 5.24922 2.35184 5.19391 2.25338 5.09545C2.15492 4.99699 2.09961 4.86346 2.09961 4.72422C2.09961 4.58498 2.15492 4.45144 2.25338 4.35299C2.35184 4.25453 2.48537 4.19922 2.62461 4.19922H7.87461ZM6.02766 15.9907C6.08691 16.5025 6.33221 16.9746 6.7169 17.3173C7.10159 17.66 7.59882 17.8493 8.11401 17.8492H12.8852C13.4004 17.8493 13.8976 17.66 14.2823 17.3173C14.667 16.9746 14.9123 16.5025 14.9716 15.9907L16.2106 5.24922H4.78866L6.02766 15.9907ZM8.92461 7.87422C9.06385 7.87422 9.19738 7.92953 9.29584 8.02799C9.3943 8.12644 9.44961 8.25998 9.44961 8.39922V14.6992C9.44961 14.8385 9.3943 14.972 9.29584 15.0705C9.19738 15.1689 9.06385 15.2242 8.92461 15.2242C8.78537 15.2242 8.65183 15.1689 8.55338 15.0705C8.45492 14.972 8.39961 14.8385 8.39961 14.6992V8.39922C8.39961 8.25998 8.45492 8.12644 8.55338 8.02799C8.65183 7.92953 8.78537 7.87422 8.92461 7.87422ZM12.5996 8.39922C12.5996 8.25998 12.5443 8.12644 12.4458 8.02799C12.3474 7.92953 12.2138 7.87422 12.0746 7.87422C11.9354 7.87422 11.8018 7.92953 11.7034 8.02799C11.6049 8.12644 11.5496 8.25998 11.5496 8.39922V14.6992C11.5496 14.8385 11.6049 14.972 11.7034 15.0705C11.8018 15.1689 11.9354 15.2242 12.0746 15.2242C12.2138 15.2242 12.3474 15.1689 12.4458 15.0705C12.5443 14.972 12.5996 14.8385 12.5996 14.6992V8.39922Z" fill="#1D4ED8"/>
                        </svg>
                        <span>Delete</span>
                      </button>
                      <button className="blue-btn active" aria-label="Add More Language">
                        <span>Add More Language</span>
                      </button>
                   </div>
                 </div>
              </div>

              <div className="details-offline-block">
                 <h5>A Victory LAP by Steven Sakadales</h5>
                 <div className="flex wrap-dropdown  gap20">
                   <div className="global-dropdown-block m-0">
                     <label>Target Language</label>
                     <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Chinese(Simplified)' }}
                    />
                   </div>
                   <div className="global-dropdown-block m-0">
                     <label>Select Hubs</label>
                     <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Select Hub' }}
                    />
                   </div>
                   <div className="global-dropdown-block m-0">
                     <label>Select Stream</label>
                     <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        className="global-dropdown-select"
                        defaultValue={{ label: 'Select Stream' }}
                    />
                   </div>
                   <div className="flex btn-gap border-line">
                      <button className="blue-btn" aria-label="Delete">
                        <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                          <path d="M8.92461 4.19922H12.0746C12.0746 3.7815 11.9087 3.3809 11.6133 3.08553C11.3179 2.79016 10.9173 2.62422 10.4996 2.62422C10.0819 2.62422 9.68129 2.79016 9.38592 3.08553C9.09055 3.3809 8.92461 3.7815 8.92461 4.19922ZM7.87461 4.19922C7.87461 3.50303 8.15117 2.83535 8.64345 2.34306C9.13574 1.85078 9.80342 1.57422 10.4996 1.57422C11.1958 1.57422 11.8635 1.85078 12.3558 2.34306C12.848 2.83535 13.1246 3.50303 13.1246 4.19922H18.3746C18.5138 4.19922 18.6474 4.25453 18.7458 4.35299C18.8443 4.45144 18.8996 4.58498 18.8996 4.72422C18.8996 4.86346 18.8443 4.99699 18.7458 5.09545C18.6474 5.19391 18.5138 5.24922 18.3746 5.24922H17.2679L16.0142 16.1104C15.9256 16.8782 15.5578 17.5865 14.9809 18.1008C14.4039 18.615 13.6581 18.8992 12.8852 18.8992H8.11401C7.34116 18.8992 6.5953 18.615 6.01835 18.1008C5.4414 17.5865 5.07363 16.8782 4.98501 16.1104L3.73131 5.24922H2.62461C2.48537 5.24922 2.35184 5.19391 2.25338 5.09545C2.15492 4.99699 2.09961 4.86346 2.09961 4.72422C2.09961 4.58498 2.15492 4.45144 2.25338 4.35299C2.35184 4.25453 2.48537 4.19922 2.62461 4.19922H7.87461ZM6.02766 15.9907C6.08691 16.5025 6.33221 16.9746 6.7169 17.3173C7.10159 17.66 7.59882 17.8493 8.11401 17.8492H12.8852C13.4004 17.8493 13.8976 17.66 14.2823 17.3173C14.667 16.9746 14.9123 16.5025 14.9716 15.9907L16.2106 5.24922H4.78866L6.02766 15.9907ZM8.92461 7.87422C9.06385 7.87422 9.19738 7.92953 9.29584 8.02799C9.3943 8.12644 9.44961 8.25998 9.44961 8.39922V14.6992C9.44961 14.8385 9.3943 14.972 9.29584 15.0705C9.19738 15.1689 9.06385 15.2242 8.92461 15.2242C8.78537 15.2242 8.65183 15.1689 8.55338 15.0705C8.45492 14.972 8.39961 14.8385 8.39961 14.6992V8.39922C8.39961 8.25998 8.45492 8.12644 8.55338 8.02799C8.65183 7.92953 8.78537 7.87422 8.92461 7.87422ZM12.5996 8.39922C12.5996 8.25998 12.5443 8.12644 12.4458 8.02799C12.3474 7.92953 12.2138 7.87422 12.0746 7.87422C11.9354 7.87422 11.8018 7.92953 11.7034 8.02799C11.6049 8.12644 11.5496 8.25998 11.5496 8.39922V14.6992C11.5496 14.8385 11.6049 14.972 11.7034 15.0705C11.8018 15.1689 11.9354 15.2242 12.0746 15.2242C12.2138 15.2242 12.3474 15.1689 12.4458 15.0705C12.5443 14.972 12.5996 14.8385 12.5996 14.6992V8.39922Z" fill="#1D4ED8"/>
                        </svg>
                        <span>Delete</span>
                      </button>
                      <button className="blue-btn active" aria-label="Add More Language">
                        <span>Add More Language</span>
                      </button>
                   </div>
                 </div>
              </div>
			</div>
		 </div>

	  </div>
	</section>
 </div>
 <div className="stricy-btn flex flex-center no-rightlist fourBtn">
   <div className="left flex">
      <div><button className="btn-default">Save and Exit Project</button></div>
      <div><button className="btn-default">Cancel Project</button></div>
   </div>
   <div className="left flex">
      <div><button className="btn-default">Back</button></div>
      <div><button className="btn" disabled="">Next</button></div>
   </div>
</div>
</div>
  )
}
